module.exports = __webpack_public_path__ + "statics/img/cate4-4@2x.2780c2e6.png";